export function timeFormat(time?: number) {
  if (time === undefined || !isFinite(time) || isNaN(time)) {
    return undefined;
  }
  const hrs = ~~(time / 3600);
  const mins = ~~((time % 3600) / 60);
  const secs = ~~time % 60;
  const formatDigit = (digit: number) => `${digit < 10 ? '0' : ''}${digit}`;

  if (hrs > 0) {
    return `${hrs}:${formatDigit(mins)}:${formatDigit(secs)}`;
  }

  return `${mins}:${formatDigit(secs)}`;
}

export function hmsToSecondsOnly(str: string) {
  const p = str.split(':');
  let s = 0;
  let m = 1;

  while (p.length > 0) {
    s += m * parseInt(p.pop() ?? '', 10);
    m *= 60;
  }

  return s;
}
